const EMAIL_REGEX = /^[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,64}$/;
const EMAIL_MAX_LENGTH = 254;

const US_PHONE_NUMBER_REGEX = /^[2-9]\d{9}$/;

const PHONE_FORMATTING_CHARS = /[\s\-.()]/g;

export const validateEmail = (value: string): boolean =>
  value.length <= EMAIL_MAX_LENGTH && EMAIL_REGEX.test(value);

export const normalizePhoneNumber = (raw: string): string =>
  raw.replace(PHONE_FORMATTING_CHARS, '');

export const validatePhoneNumber = (value: string): boolean =>
  US_PHONE_NUMBER_REGEX.test(normalizePhoneNumber(value));
